"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariablesToTest = exports.getRelatedVar = exports.extractBlangVar = void 0;
var lodash_1 = __importDefault(require("lodash"));
var variableRef_1 = require("./variableRef");
// In production we have a maximum depth of 150
// but typescript don't compile with a high depth
// (cf Type instantiation is excessively deep and possibly infinite)
// We set this variable arbitrarily. This does not pose any execution problems.
// const MAX_BLANG_DEPTH = 16;
/**
 * Find all blang variable object (cf @ ParsedRuleVariableGeneric<"variable">) on a parsed blang expression
 * @param parsedBlangExpr @BlangExpType<typeof MAX_BLANG_DEPTH> a multi dimensional array describing the blang expression
 * @returns @Array<ParsedRuleVariableGeneric<'variable'>> a flat array with all variables in the input
 */
var extractBlangVar = function (
// parsedBlangExpr: BlangExpType<typeof MAX_BLANG_DEPTH> | BlangSubExpType,
parsedBlangExpr) {
    var inputAsArray = Array.isArray(parsedBlangExpr) ? parsedBlangExpr : [parsedBlangExpr];
    return inputAsArray.reduce(function (acc, rule) {
        if (!Array.isArray(rule)) {
            // Only get object of type variable (cf ParsedRuleVariableGeneric<'variable'>)
            if (rule !== null && typeof rule !== 'string' && rule.type === 'variable') {
                return __spreadArray(__spreadArray([], __read(acc), false), [rule], false);
            }
        }
        else {
            // Recursive call
            return __spreadArray(__spreadArray([], __read(acc), false), __read((0, exports.extractBlangVar)(rule)), false);
        }
        return acc;
    }, []);
};
exports.extractBlangVar = extractBlangVar;
// Check in variablesRef is there is related var (ie $text = $body + $title)
var getRelatedVar = function (allVar, variablesRef) {
    var relatedVar = allVar.map(function (rule) {
        // variable name can be a single name or name<.>subpath. Here we only look at the first part
        var varName = (rule.value.includes('.') ? rule === null || rule === void 0 ? void 0 : rule.value.split('.')[0] : rule.value);
        if (variablesRef[varName])
            if (variablesRef[varName].relatedFields) {
                // If the variable is not in the ref we don't display it
                return variablesRef[varName].relatedFields;
            }
            else {
                return varName;
            }
        return null;
    });
    return lodash_1.default.compact(lodash_1.default.uniq(relatedVar.flat())); // remove undefined values and flat the array
};
exports.getRelatedVar = getRelatedVar;
/** *
 * getVariablesToTest
 * Depends on the BLANG query, we display test fields on the right panel
 * @ruleVariables : a multi dimensional array containing or blang expression parsed.
 * This array comes from the /validate ws
 * @variablesRef  : a static list of all the possible variables in BLANG.
 */
var getVariablesToTest = function (
// parsedBlangExpr: BlangExpType<typeof MAX_BLANG_DEPTH> | BlangSubExpType,
parsedBlangExpr, variablesRef) {
    if (variablesRef === void 0) { variablesRef = variableRef_1.VARIABLES_REF; }
    var onlyBlangVarArray = (0, exports.extractBlangVar)(parsedBlangExpr);
    var withRelated = (0, exports.getRelatedVar)(onlyBlangVarArray, variablesRef);
    return withRelated;
};
exports.getVariablesToTest = getVariablesToTest;
